import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';
import {VideoPopup} from '../features/video-popup';
import parallaxHero from '../features/parallax-hero';
import {compareImages} from '../features/compare-images';
import {newsletterCheckForResultSection} from '../globals/newsletter';

import {VideoBackground} from './video-background';

register('custom-content', [slider, parallaxHero, compareImages, newsletterCheckForResultSection]);

if (!customElements.get('video-background')) {
  customElements.define('video-background', VideoBackground);
}

if (!customElements.get('video-popup')) {
  customElements.define('video-popup', VideoPopup);
}
